import React, { useRef } from "react";
import { Modal, Form, Select } from "antd";


export default function UserCustomerModal({ openingViaLogin, isVisible, onOk, onCancel, customerListState, userCustomerList }) {
    const CustomerFormRef = useRef(null);

    const handleCustomerOk = async () => {
        try {
            let formResult = await CustomerFormRef?.current?.validateFields();

            const customer = userCustomerList?.find(item => item?.cardCode === formResult?.cardCode);

            if (customer) {
                localStorage.setItem("cardCode", customer?.cardCode);
                localStorage.setItem("cardName", customer?.cardName);
            }

            onOk();
            window.location.reload();

        } catch (error) {
            // Handle error if needed
        }
    };

    return (
        <Modal
            maskClosable={false}
            closable={false}
            title="Select Customer"
            style={{ top: 150 }}
            width={500}
            visible={isVisible}
            okText={'Select'}
            onOk={handleCustomerOk}
            onCancel={onCancel}
            cancelButtonProps={{ style: { display: openingViaLogin ? 'none' : 'inline-block' } }}
        >
            <Form layout="horizontal" ref={CustomerFormRef}>
                <Form.Item
                    name="cardCode"
                    label="Company Name:"
                    rules={[{ required: true, message: "", whitespace: true }]}
                >
                    <Select
                        className='hp-w-100'
                        placeholder="Select Company"
                        allowClear
                        showSearch
                        filterOption={true}
                        optionFilterProp="children"
                    >
                        {customerListState}
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    );
}
